<div class="header loan-section">
  <h3>Online Business Loan Application</h3>
  <div class="progress-container">
    @for (idx of businessLoanState.maxLoanSteps | fill; track idx) {
      <div
        class="progress-item"
        [ngStyle]="{
          height: idx <= businessLoanState.currentPart ? '4px' : '1px',
          'background-color': idx <= businessLoanState.currentPart ? '#b9975b' : '#BBBBBB',
        }"
      ></div>
    }
  </div>
</div>

<div class="loan-main-content">
  <router-outlet></router-outlet>
</div>
